export function getAccount(config) {
    const uid = config.state.current;
    const connection = config.state.connections.get(uid);
    const accounts = connection?.accounts;
    const account = accounts?.[0];
    const chain = config.chains.find((chain) => chain.id === connection?.chainId);
    const status = config.state.status;
    switch (status) {
        case 'connected':
            return {
                account: account,
                accounts: accounts,
                chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status,
            };
        case 'reconnecting':
            return {
                account: account,
                accounts: accounts,
                chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: !!account,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status,
            };
        case 'connecting':
            return {
                account: account,
                accounts: accounts,
                chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status,
            };
        case 'disconnected':
            return {
                account: undefined,
                accounts: undefined,
                chain: undefined,
                chainId: undefined,
                connector: undefined,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status,
            };
    }
}
//# sourceMappingURL=getAccount.js.map